import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Self-hosted variable fonts (doc 020): Inter for body/UI, Fraunces for the
// editorial serif headings. Imported here so they load app-wide before render.
import "@fontsource-variable/inter";
import "@fontsource-variable/fraunces";
import "./i18n";
import App from "./App";
import { initIntegrations } from "./lib/integrations";

initIntegrations();

const gaId = import.meta.env.VITE_GA_PLATFORM_MEASUREMENT_ID as string | undefined;
if (gaId) {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", gaId);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
